document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.body.classList.add('page-loaded');
  }, 1);
});

if (document.querySelector('.js-no-margins-breadcrumb')) {
  if (document.querySelector('.zonetop')) {
    document.querySelector('.zonetop').style.marginBottom = '0';
  }

  if (document.querySelector('.zonebottom')) {
    document.querySelector('.zonebottom').style.marginTop = '0';
  }

  if (document.querySelector('.catalog-grid')) {
    document.querySelector('.catalog-grid').style.marginTop = '0';
  }

  document.querySelectorAll('#breadcrumb').forEach((item) => {
    item.style.display = 'none';
  });
}